import { createStore } from 'vuex'
import VuexPersistence from 'vuex-persist'

import auth from '@/modules/auth/store'
import creditReturns from '@/modules/creditReturns/store'
import orderQueries from '@/modules/orderQueries/store'
import purchaseOrders from '@/modules/purchaseOrders/store'
import products from '@/modules/dataMaintenance/store'

import bannerGroups from './bannerGroups'
import dataMaintenance from './dataMaintenance'
import familyGroups from './familyGroups'
import freightInfo from './freightInfo'
import instructions from './instructions'
import notifications from './notifications'
import multiStoreOperators from './multiStoreOperators'
import pricingRegions from './pricingRegions'
import profile from './profile'
import preferences from './preferences'
import retailerInvites from './retailerInvites'
import stores from './stores'
import tenant from './tenant'
import supplierRetailerRange from './supplierRetailerRange'

export const storeModules = {
  auth,
  retailerInvites,
  tenant,
  creditReturns,
  dataMaintenance,
  familyGroups,
  freightInfo,
  instructions,
  notifications,
  orderQueries,
  purchaseOrders,
  pricingRegions,
  products,
  profile,
  preferences,
  multiStoreOperators,
  bannerGroups,
  stores,
  supplierRetailerRange
}

export function createStoreOptions() {
  const vuexLocal = new VuexPersistence({
    storage: window.localStorage,
    modules: ['preferences']
  })

  return {
    modules: storeModules,
    plugins: [vuexLocal.plugin]
  }
}

export function createAppStore() {
  return createStore(createStoreOptions())
}
